import { ProviderToken } from '@angular/core'
import { BootstrapData } from 'elements-sdk'
import type { LazyLoaderService } from 'root/app.module'

export const BOOTSTRAP_DATA = 'BOOTSTRAP_DATA' as unknown as ProviderToken<BootstrapData>
export const LAZY_LOADER = 'LAZY_LOADER' as unknown as ProviderToken<LazyLoaderService>
